export const Routes = {
  DEFAULT: "/",
  HOME: "/",
  CONTACT_US: "https://medoc.life/contact-us",
  ABOUT_US: "https://medoc.life/about-us",
  LOGIN: "https://app.medoc.life",
};
